/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Update_User_SuccessInputs */



/**
* | output |
* | --- |
* | "User permissions updated successfully!" |
*
* @param {Spaces_Update_User_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_update_user_success = /** @type {((inputs?: Spaces_Update_User_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Update_User_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Benutzerberechtigungen erfolgreich aktualisiert!")
	return /** @type {LocalizedString} */ ("User permissions updated successfully!")
});